import { transform } from "@babel/core";
import { GoogleMap, LoadScriptNext, Polygon, Marker, OverlayView } from "@react-google-maps/api";
import React, { useState, useEffect } from 'react'
import { CreateUrl, CallGetAPI, CallPutAPI, CallPostAPI } from 'Utils/ApiHelper.js';
import { Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useMobileLandscape, useTabletContext } from '../../Context/ContextProvider'


interface Props {
    onMapLoad: (map) => void
    markers: Array<GPS>
    handleMarkerClick: (marker: GPS) => void
    showTooltip: boolean
    clickedMarker: number | null | undefined
    handleTooltipCloseClick: () => void
    deviceOverviewClick: (serial: number | null) => void
    center: Coordinates
    deviceGraphClick: (id: number) => void
}

interface GPS {
    position: { lat: number, lng: number }
    icon: string
    serial: number
    id: number
    deviceName: string
}

interface Coordinates {
    lat: number
    lng: number
}

const GoogleMapsMobileDash: React.FC<Props> = ({
    onMapLoad,
    markers,
    handleMarkerClick,
    showTooltip,
    clickedMarker,
    handleTooltipCloseClick,
    deviceOverviewClick,
    center,
    deviceGraphClick
}) => {
    const isTablet = useTabletContext()
    const isLandscape = useMobileLandscape()
    const [mapKey, setMapKey] = useState<string>("")

    useEffect(() => {
        CallGetAPI(CreateUrl('/api/aquaguard/mapkey'), {})
            .then(data => {
                setMapKey(data)
            })
            .catch(err => console.log(err));

    }, [])

    

    const containerStyle = {
        height: "50vh",
        width: (isLandscape || isTablet) ? "100%" : "110%",
        transform: (isLandscape || isTablet) ? 'none' : 'translateX(-5%)',
        minHeight: "20px",
        touchAction: 'auto'
    };

    const mapStyles = [
        {
            featureType: "poi",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide all labels for Points of Interest (e.g., hospital, park)
        },
        {
            featureType: "poi.business",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide business-related labels (e.g., shops, restaurants)
        },
        {
            featureType: "poi.medical",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide medical-related labels (e.g., hospital, clinic)
        },
        {
            featureType: "poi.place_of_worship",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide places of worship labels
        },
        {
            featureType: "poi.school",
            elementType: "labels",
            stylers: [{ visibility: "off" }], // Hide school labels
        }
    ];
    

    return (
        <div style={{ width: "100%" }}>
            {mapKey &&  <LoadScriptNext googleMapsApiKey={mapKey}>
                <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    onLoad={onMapLoad}
                    options={{
                        styles: mapStyles,
                        disableDefaultUI: false
                    }}
                    //onClick={showTooltip ? ():void => handleTooltipCloseClick() : ():void => console.log('nothing slelected')}

                >
                    
                    {markers.length > 0 && markers.map((marker) => {
                        return (<React.Fragment key={marker.serial}>
                            <Marker
                                key={marker.id}
                                position={marker.position}
                                icon={marker.icon}
                                onClick={(): void => handleMarkerClick(marker) }
                            />
                            {showTooltip && (clickedMarker === marker.id) && (<OverlayView
                                key={marker.serial}
                                position={marker.position}
                                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                            >
                                <div style={{
                                    background: "white",
                                    padding: "5px",
                                    borderRadius: "3px",
                                    boxShadow: "0px 0px 6px rgba(0,0,0,0.2)",
                                    width: "210px",
                                    display: "flex", 
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transform: "translate(-50%, -50px)"
                                }}>
                                    <div>
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <div>
                                                <h5 style={{textAlign: "center", fontSize: "18px"} }><b>Serial: {marker.serial}</b></h5>
                                                <h5 style={{marginTop: "-10px", textAlign: "center"} }>Device Name: {marker.deviceName ? marker.deviceName : 'Not Set'}</h5>
                                            </div>
                                        </div>
                                        <div style={{ display: "flex", margin: "0 8px 8px 8px" }}>
                                            <Button variant="contained" color="warning" style={{ marginRight: "10px" }} onClick={():void => deviceGraphClick(clickedMarker)}>Graph</Button>
                                            <Button variant="contained" onClick={(e): void => { e.stopPropagation(); window.scrollTo(0, 0); deviceOverviewClick(marker.serial)}}>Overview</Button>
                                        </div>
                                    </div>
                                </div>
                            </OverlayView>)}
                        </React.Fragment>)
                    })}
                </GoogleMap>
            </LoadScriptNext>}
        </div>
    )
}
export default GoogleMapsMobileDash